import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "mn_lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return saved === "nl" ? "nl" : "fr";
    } catch (e) {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang === "nl" ? "nl" : "fr";
    } catch (e) {
      /* ignore */
    }
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations.fr;
      let str = dict[key] != null ? dict[key] : translations.fr[key];
      if (str == null) return key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.replace(`{${k}}`, vars[k]);
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
